import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { AgentCardDisplayComponent, VirtualCardData } from '../agent-card';

@Component({
  selector: 'etxe-compliance-hoguet-section',
  imports: [MatIconModule, AgentCardDisplayComponent],
  templateUrl: './compliance-hoguet-section.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ComplianceHoguetSectionComponent {
  readonly audience = input<'owner' | 'pro' | 'all'>('all');

  readonly sampleCard: VirtualCardData = {
    number: 'CPI 6401 2026 000 012 345',
    expiresAt: '2028-05-15T00:00:00.000Z',
    companyName: 'AQUITAINE ETXE IMMOBILIER SAS',
    siren: '892345678',
    type: 'titulaire',
    cci: {
      id: 'CCI-64',
      name: 'Bayonne Pays Basque',
      president: { firstName: 'Jean-Baptiste', lastName: 'DUPONT' },
    },
    leader: {
      firstName: 'Sophie',
      lastName: 'ERRAMUZPE',
    },
    address: {
      streetNumber: '14',
      streetType: 'Avenue',
      streetName: 'du 1er mai',
      zipCode: '64100',
      city: 'Bayonne',
    },
    mentions: {
      transaction: true,
      management: true,
      syndic: false,
      listBroker: false,
      tourism: false,
      service: false,
    },
    insurer: {
      name: 'Assurance SA',
      address: {
        streetNumber: '89',
        streetType: 'Rue',
        streetName: 'la Boétie',
        zipCode: '75008',
        city: 'Paris',
      },
    },
  };
}
